import styled, { css } from 'styled-components/macro';
import { applyStyleModifiers } from 'styled-components-modifiers';

const HELPER_TITLE_MODIFIERS = {
  xbase: ({ theme }) => css`
    font-weight: ${theme.weight.xbase};
  `,
  bottomMargin: ({ theme }) => css`
    margin-bottom: ${theme.spacing.l};
  `
};

const HelperTitle = styled.h3`
  font-size: ${props => props.theme.sizes.l};
  font-weight: ${props => props.theme.weight.light};
  color: ${props => props.theme.colors.base};
  ${applyStyleModifiers(HELPER_TITLE_MODIFIERS)};
`;

export default HelperTitle;
